import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkChangeEntry } from '../types';

const onArchiveEntry: IThunkChangeEntry = thunk(async (_, { entryId, ...client }) => {
  await api.communityEngagement.archiveEntry(client, entryId);
});

export default onArchiveEntry;
